// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiFormatVerticalAlignTop } from "@mdi/js";

import { ToolbarButton } from "components/base";

import { useXdaSettingsStore } from "../../context";
import { selectHangWellsToTop } from "../../context/xdaSettingsSelectors";

function XdaHangToggle() {
  const hangWellsToTop = useXdaSettingsStore(selectHangWellsToTop);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);

  const handleToggle = (active: boolean) => {
    updateXdaSettings({ hangWellsToTop: active });
  };

  return (
    <ToolbarButton
      icon={<Icon path={mdiFormatVerticalAlignTop} size={1.5} />}
      active={hangWellsToTop}
      tooltipText={"Hang to Top Zone"}
      data-testid="xda-hang-toggle"
      overflowLabel={"Hang to Top Zone"}
      onToggle={handleToggle}
      styleKey="xdaToolbar"
    />
  );
}

export default XdaHangToggle;
